"use strict";
exports.__esModule = true;
exports.forDocumentReady = void 0;
/**
 * Waits until document is loaded
 * Creates a promise that resolves when the document.readyState is on targetReadyState
 */
function forDocumentReady(targetReadyState) {
    if (targetReadyState === void 0) { targetReadyState = 'complete'; }
    if (document.readyState === targetReadyState ||
        document.readyState === 'complete') {
        return Promise.resolve();
    }
    return new Promise(function (resolve) {
        window.addEventListener('readystatechange', function () {
            if (document.readyState === targetReadyState ||
                document.readyState === 'complete') {
                resolve();
            }
        });
    });
}
exports.forDocumentReady = forDocumentReady;
